(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var _views_Swap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49917);


// import Home from '../views/Home'

var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swr__WEBPACK_IMPORTED_MODULE_1__/* .SWRConfig */ .J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_Swap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9363,5855,1021,561,5652,1586,7893,7567,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);